import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertProbability'
})

export class ConvertProbabilityPipe implements PipeTransform {

  transform(value: string): string {
    switch (value) {
      case 'H':
        return $localize`High`;
      case 'M':
        return $localize`Medium`;
      case 'L':
        return $localize`Low`;
      default:
        return '';
    }
  }
}
